import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import axios from "axios";
import moment from "moment";
import { trackPromise } from "react-promise-tracker";

import BackdatePlaceholderForm from "../../components/page/backdatePlaceholders/backdatePlaceholderForm/BackdatePlaceholderForm";
import Count from "../../components/general/Count/Count";

class BackdatePlaceholderPage extends Component {
  state = {
    remainingCredits: null
  };

  componentDidMount = async () => {
    try {
      await trackPromise( axios.get(`${process.env.REACT_APP_GRAPHHOPPER_URL}&point=999.131,12.414&point=48.224,3.867`));
    } catch (err) {
      if (err.response) {
        let res = err.response;
        this.setState({
          remainingCredits: res.headers["x-ratelimit-remaining"]
        });
      } else {
        console.log(err);
      }
    }
  };

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>Boxi Admin | Backdate Placeholders</title>
        </Helmet>
        <Row className="mb-4">
          <Col xs={4} lg={3}>
            <Count count={this.state.remainingCredits}>
              Remaining
              <br />
              Credits
            </Count>
          </Col>
        </Row>
        <Row>
          <Col>
            <BackdatePlaceholderForm />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default BackdatePlaceholderPage;
